'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _redux = require('redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _mozart_ui = require('@pgforsta/mozart_ui');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotFound = (_dec = (0, _reactRedux.connect)(null, function (dispatch) {
  return (0, _redux.bindActionCreators)({
    pushState: _reactRouterRedux.routeActions.push }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NotFound, _Component);

  function NotFound() {
    (0, _classCallCheck3.default)(this, NotFound);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  NotFound.prototype.render = function render() {
    var styles = require('./NotFound.scss');
    return _react2.default.createElement(
      'div',
      { className: 'container' },
      _react2.default.createElement(_reactHelmet2.default, { title: 'Not Found' }),
      _react2.default.createElement(
        'div',
        { className: styles.binary_notfound },
        _react2.default.createElement(
          'div',
          { style: { marginLeft: 'auto', marginRight: 'auto', width: '500px', maxWidth: '100%' } },
          _react2.default.createElement(_mozart_ui.Image, { src: '/img/broken_robot.png' })
        ),
        _react2.default.createElement(
          'p',
          { style: { fontSize: '30px', fontWeight: 300, textAlign: 'center' } },
          'Sorry, we are having technical difficulties.'
        ),
        _react2.default.createElement(
          'p',
          { style: { fontSize: '20px', fontWeight: 300, textAlign: 'center' } },
          'Please try your request again or click',
          _react2.default.createElement(
            'a',
            { onClick: function onClick() {
                _reactRouter.browserHistory.goBack();
                setTimeout(function () {
                  window.location.reload();
                }, 500);
              } },
            ' here'
          ),
          ' to go back.'
        )
      )
    );
  };

  return NotFound;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = NotFound;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/NotFound.js
// module id = 1623
// module chunks = 0